import { SR_API_ACTION_ADMIN_GET_HOMEBASE_EMPLOYEES } from 'api/actionTypes';

export default async function getHomebaseEmployeeList({ state, apiClient }) {
  if (state.get(['homebaseEmployees'])) {
    return;
  }
  const result = await apiClient.postWithState({
    action: SR_API_ACTION_ADMIN_GET_HOMEBASE_EMPLOYEES,
    state: state,
    onSuccess(homebaseEmployees) {
      state.set(['homebaseEmployees'], homebaseEmployees || null);
    },
  });

  return result;
}
